module.exports = __webpack_public_path__ + "assets/img/bottom-bg-a3991095.png";